import { createContext, useContext } from 'react';

export interface TenantSettings {
  allowCreateCommunity?: boolean;
  // add other settings as needed
}

export interface Tenant {
  id: string;
  name: string;
  slug: string;
  logo: string | null;
  logoWithName: string | null;
  banner: string | null;
  landingPageHtml: string | null;
  themeColors?: { primary?: string | null } | null;
  allowCreateCommunity: boolean;
  communityCount: number;
  settings: TenantSettings;
  redirectToLogin: boolean;
  /** Default true when missing. When false, iOS WebView uses html5-qrcode instead of native bridge. */
  iosUseNativeQrScanner?: boolean;
  rootCommunityId?: string | null;
  rootCommunityKind?: string | null;
  isRootAggregator?: boolean;
}

export interface TenantContextType {
  tenant: Tenant | null;
  isLoading: boolean;
  isWhitelabel: boolean;
}

export const TenantContext = createContext<TenantContextType>({
  tenant: null,
  isLoading: true,
  isWhitelabel: false,
});

export const useTenant = () => useContext(TenantContext);
